<template>
  <v-btn icon @click="back" flat density="comfortable" color="transparent">
    <v-icon color="primary">mdi-chevron-left</v-icon>
  </v-btn>
</template>
<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

const router = useRouter()
const route = useRoute()
const store = useStore()

function back() {
  router.back()
}
</script>
